import $http from '@Config/axios';

export const AssinaturaMedicamentoPresenter = {
	update: params => $http.put(`assinaturamedicamento/${params.id}`, params),
	pausarMedicamento: (id, ciclos, motivo) => $http.post(`assinaturamedicamento/${id}/pausas`, { ciclos, motivo }),
	editarMedicamento: (pausa_id, ciclos, motivo, user_id) => $http.put(`assinaturamedicamento/${pausa_id}/pausas`, { ciclos, motivo, user_id }),
	deletarPausaMedicamento: pausa_id => $http.delete(`assinaturamedicamento/${pausa_id}/pausas`)
};
